<template>
  <div class="side-buttons-bar" v-b-scrollspy>
    <b-button
      @click="goTop"
      class="bd-button top-button mr-2"
      v-b-tooltip.hover.bottom
      :title="$t('top')"
    >
      <i class="fas fa-rocket"></i>
    </b-button>
  </div>
</template>

<script>
export default {
  methods: {
    goTop() {
      document.getElementsByClassName('main-content')[0].scrollTop = 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.side-buttons-bar {
  position: fixed;
  bottom: 120px;
  right: 10px;
  transform: rotate(-90deg);
  transform-origin: right bottom;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.top-button {
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2rem;
  transform: rotate(45deg);
  font-size: 1.5rem;
  .fas {
    transform: translate(-2px, 2px); 
  }
}
</style>

<i18n src="@/locales/parts/right-bottom-button-group/RightBottomButtonGroup.json"></i18n>